/** `validateSearch` of `/knowledge/new` (`AM-132 point 11`, 13 §4.2.2): the ticket to precharge from. */
export interface KnowledgeNewSearch {
  fromTicketId?: string;
}

export function knowledgeNewSearchSchema(search: Record<string, unknown>): KnowledgeNewSearch {
  const fromTicketId = search['fromTicketId'];
  return typeof fromTicketId === 'string' && fromTicketId.length > 0 ? { fromTicketId } : {};
}
